"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _TabDrawer = _interopRequireDefault(require("../components/TabDrawer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function TabDrawer(_ref) {
  var scriptId = _ref.scriptId;
  return _react.default.createElement(_commonReact.CommentsProvider, {
    resourceId: scriptId
  }, _react.default.createElement(_TabDrawer.default, null));
}

var _default = TabDrawer;
exports.default = _default;